import { ProdutoServicoDropDown } from "../../../../../common/domain/models/produto_servico_dropdown";
import { IGetProdutoServicoByIdOrdemCompraDropDownUseCase } from "../../../presentation/useCases/read/get_produto_servico_by_id_ordem_compra_drop_down_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetProdutoServicoByIdOrdemCompraDropDownUseCase
 */

export class GetProdutoServicoByIdOrdemCompraDropDownUseCase
  implements IGetProdutoServicoByIdOrdemCompraDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getProdutoServicoByIdOrdemCompraDropDown(
    idOrdemCompra: number | undefined,
  ): Promise<ProdutoServicoDropDown[]> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao buscar id de ordem de compra!');
    return await this.repository.getProdutoServicoByIdOrdemCompraDropDown(
      idOrdemCompra,
    );
  }
}
